import { MD3LightTheme, MD3Theme } from 'react-native-paper';
import { green, sand, white } from './colors';

export interface RouteTheme {
  statusBarStyle: 'light-content' | 'dark-content';
  topSafeAreaBackground: string;
  bottomSafeAreaBackground: string;
}

export const defaultTheme: MD3Theme = {
  ...MD3LightTheme,
  colors: {
    ...MD3LightTheme.colors,
    background: sand,
    surface: white,
    primary: green,
    outline: green,
    outlineVariant: green,
  },
};
